import { LexicalEditor } from 'lexical';

type SavedScroll = Array<{ el: HTMLElement; top: number }>;

function findScrollContainers(element: HTMLElement | null): SavedScroll {
  const saved: SavedScroll = [];
  let current = element?.parentElement;
  while (current && current !== document.documentElement) {
    const style = getComputedStyle(current);
    const overflowY = style.overflowY;
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      current.scrollHeight > current.clientHeight
    ) {
      saved.push({ el: current, top: current.scrollTop });
    }
    current = current.parentElement;
  }
  return saved;
}

function restoreScrollPositions(saved: SavedScroll): void {
  for (const { el, top } of saved) {
    el.scrollTop = top;
  }
}

// Safety net if SKIP_SCROLL_INTO_VIEW_TAG and overflow-anchor:none don't fully
// prevent scroll shifts. Can happen when reflow changes element sizes after a
// full content replacement.
export function captureScrollPosition(editor: LexicalEditor): (onComplete?: () => void) => void {
  const saved = findScrollContainers(editor.getRootElement());

  // Restore across two animation frames (Lexical, browser, React):
  //   Immediate: Lexical's synchronous DOM reconciliation
  //   1st rAF:   browser reflow/paint (element sizes settle, scroll adjusts)
  //   2nd rAF:   React re-renders from mutation listeners can trigger another reflow
  return (onComplete?: () => void) => {
    restoreScrollPositions(saved);

    requestAnimationFrame(() => {
      restoreScrollPositions(saved);

      requestAnimationFrame(() => {
        restoreScrollPositions(saved);
        onComplete?.();
      });
    });
  };
}
